import * as types from "../types/templates";
import { call, put, takeEvery, all } from "redux-saga/effects";
import {
  fetchAllEmailTemplates,
  fetchAllSMSTemplates,
  deleteMultipleTemplatesArray,
  deleteSingleTemplate,
} from "../../networking/templates/networking";

function* fetchEmailTemplatesList(action) {
  try {
    if (action.payload) {
      const templates = yield call(fetchAllEmailTemplates, action.payload);
      if (templates.error === null) {
        yield put({
          type: types.SET_EMAIL_TEMPLATES_CONTENT,
          content: templates.payload,
        });
      } else {
        throw new Error({ error: "Kunne ikke hente kundeliste." });
      }
    } else {
      throw new Error({ error: "Kunne ikke hente kunder." });
    }
  } catch ({ error }) {
    yield put({ type: types.REVOKE_EMAIL_TEMPLATES_CONTENT, message: error });
  }
}

function* fetchSMSTemplatesList(action) {
  try {
    if (action.payload) {
      const templates = yield call(fetchAllSMSTemplates, action.payload);
      if (templates.error === null) {
        yield put({
          type: types.SET_SMS_TEMPLATES_CONTENT,
          content: templates.payload,
        });
      } else {
        throw new Error({ error: "Kunne ikke hente kundeliste." });
      }
    } else {
      throw new Error({ error: "Kunne ikke hente kunder." });
    }
  } catch ({ error }) {
    yield put({ type: types.REVOKE_SMS_TEMPLATES_CONTENT, message: error });
  }
}

function* performRemoveSingleTemplate(action) {
  try {
    if (action.details) {
      var response = yield call(deleteSingleTemplate, action.details);
      if (response.error === null) {
        yield put({
          type: types.GRANT_DELETE_SINGLE_TEMPLATE,
          update: response.payload,
        });
        yield put({
          type: types.CHANGE_EMAIL_TEMPLATES_MODALS,
          modal: { deleteModal: false },
        });
      } else {
        throw new Error("Kunne ikke fjerne kunde.");
      }
    } else {
      throw new Error("Kunne ikke slette kunde.");
    }
  } catch ({ error }) {
    yield put({ type: types.REVOKE_DELETE_SINGLE_TEMPLATE, message: error });
    yield put({
      type: types.CHANGE_EMAIL_TEMPLATES_MODALS,
      modal: { deleteModal: false },
    });
  }
}

function* performRemoveListArray(action) {
  try {
    if (action.details) {
      const response = yield call(deleteMultipleTemplatesArray, action.details);
      if (response.error === null) {
        yield put({ type: types.GRANT_DELETE_TEMPLATE_ARRAY });
      } else {
        throw new Error("Kunne ikke slette maler.");
      }
    } else {
      throw new Error("Kunne ikke slette maler.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_DELETE_TEMPLATE_ARRAY, message: e });
  }
}

function* templatesSaga() {
  yield all([
    takeEvery(types.REQUEST_EMAIL_TEMPLATES_CONTENT, fetchEmailTemplatesList),
    takeEvery(types.REQUEST_SMS_TEMPLATES_CONTENT, fetchSMSTemplatesList),
    takeEvery(
      types.REQUEST_DELETE_SINGLE_TEMPLATE,
      performRemoveSingleTemplate
    ),
    takeEvery(types.REQUEST_DELETE_TEMPLATE_ARRAY, performRemoveListArray),
  ]);
}

export default templatesSaga;
